import { toast } from 'react-toastify';
import { ActionLog } from 'types/funifier';
import { api } from './api';

// import { Attributes } from '../models/ActionLog.types';
// import { storageGet } from './storage';

// const useQuery = () => {
//   return new URLSearchParams(window.location.search);
// };

export const registerRewardBehavior: any = (
  userId: string,
  actionId: string,
  attributes?: any,
  notificationType = 'modal',
  notificationMessage = '',
  _id?: string,
) => {
  return new Promise((resolve, reject) => {
    // const global = storageGet('global'),

    const _attributes = Object.assign({}, attributes);

    // query = useQuery();
    // _attributes.time = new Date().getTime();

    const payload = {
      _id: userId + '_' + actionId + '_' + new Date().getTime(),
      userId,
      actionId,
      time: { $date: new Date().getTime() },
      attributes: _attributes,
    };

    pushPlayerAction('registerRewardBehavior', {
      endpoint: 'database/reward_behavior__c',
      data: payload,
      method: 'POST',
    });

    api
      .post('database/reward_behavior__c', payload)
      .then(response => {
        if (response?.data?.achievements?.length) {
          const event = new Event('reload:user');
          document.dispatchEvent(event);

          try {
            if (response.data.achievements) {
              const hasAchievement = response.data.achievements.find((achievement: any) => achievement.type === 1);
              if (!!hasAchievement && response.data?.action?.actionId && response.data?.action?.actionId !== 'reward_behavior') {
                if (notificationType === 'modal') {
                  // window.postMessage(
                  //   {
                  //     type: 'achievement',
                  //     value: { name: notificationMessage },
                  //   },
                  //   '*',
                  // );
                } else {
                  // toast(`💎 You've got new achievements!`, {
                  //   position: 'top-right',
                  //   autoClose: 5000,
                  //   hideProgressBar: false,
                  //   closeOnClick: true,
                  //   pauseOnHover: true,
                  //   draggable: true,
                  //   progress: undefined,
                  // });
                }
              }
            }
          } catch (err) {
            console.log(err);
          }
        }

        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const actionLog: any = (
  userId: string,
  actionId: string,
  attributes?: any,
  notificationType = 'modal',
  notificationMessage = '',
  _id?: string,
  async = false,
) => {
  return new Promise((resolve, reject) => {
    // const global = storageGet('global'),

    const _attributes = Object.assign({}, attributes);

    // query = useQuery();
    // _attributes.time = new Date().getTime();

    const payload = {
      _id,
      userId,
      actionId,
      time: new Date().getTime(),
      attributes: _attributes,
    };

    if (actionId !== 'partial_task') {
      pushPlayerAction('actionLog', {
        endpoint: `/action/log?async=${async}`,
        data: payload,
        method: 'POST',
      });
    }

    api
      .post(`/action/log?async=${async}`, payload)
      .then(response => {
        if (response?.data?.achievements?.length) {
          const event = new Event('reload:user');
          document.dispatchEvent(event);

          try {
            if (response?.data?.achievements) {
              const hasAchievement = response?.data?.achievements?.find((achievement: any) => achievement?.type === 1);
              if (!!hasAchievement && response.data?.action?.actionId && response.data?.action?.actionId !== 'reward_behavior') {
                if (notificationType === 'modal') {
                  // window.postMessage(
                  //   {
                  //     type: 'achievement',
                  //     value: { name: notificationMessage },
                  //   },
                  //   '*',
                  // );
                } else {
                  // toast(`💎 You've got new achievements!`, {
                  //   position: 'top-right',
                  //   autoClose: 5000,
                  //   hideProgressBar: false,
                  //   closeOnClick: true,
                  //   pauseOnHover: true,
                  //   draggable: true,
                  //   progress: undefined,
                  // });
                }
              }
            }
          } catch (err) {
            console.log(err);
          }
        }

        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const registerInteractionCampaign: any = (
  userId: string,
  actionId: string,
  attributes?: any,
  notificationType = 'modal',
  notificationMessage = '',
  _id?: string,
) => {
  return new Promise((resolve, reject) => {
    // const global = storageGet('global'),

    const _attributes = Object.assign({}, attributes);

    // query = useQuery();
    // _attributes.time = new Date().getTime();

    const payload = {
      userId,
      actionId,
      time: { $date: new Date().getTime() },
      attributes: _attributes,
    };

    api
      .post('database/interaction_campaign__c', payload)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const verifyCampaign: any = (id: string) => {
  return new Promise((resolve, reject) => {
    const payload = {
      id,
    };

    api
      .post('find/verify_interaction_campaign', payload)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const actionLogBulk = (userId: string | undefined, actionId: string, attributes?: any) => {
  return new Promise((resolve, reject) => {
    const _attributes = Object.assign({}, attributes);

    const payload = {
      userId,
      actionId: actionId,
      time: new Date().getTime(),
      attributes: _attributes,
    };

    api
      .post('/action/log/bulk?async=false', [payload])
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

// Não utilizar
// export async function getActions(player: string, actionId: string): Promise<ActionLog[]> {
//   try {
//     const { data } = await api.get(`action/log`, {
//       params: {
//         player,
//         action: actionId,
//         orderby: 'time',
//         reverse: true,
//       },
//     });
//     return data;
//   } catch (e) {
//     throw e;
//   }
// }

export async function getActionById(id: string): Promise<ActionLog> {
  try {
    const { data } = await api.post(`find/get_my_recognition_by_id?strict=true`, { actionId: id });
    return data[0];
  } catch (e) {
    throw e;
  }
}

export async function updateRewardBehavior(action: ActionLog): Promise<ActionLog> {
  try {
    pushPlayerAction('updateRewardBehavior', {
      endpoint: `database/reward_behavior__c`,
      data: action,
      method: 'PUT',
    });

    const { data } = await api.put(`database/reward_behavior__c`, action);
    return data[0];
  } catch (e) {
    throw e;
  }
}

export async function updateAction(action: ActionLog): Promise<ActionLog> {
  try {
    pushPlayerAction('updateAction', {
      endpoint: `database/action_log`,
      data: action,
      method: 'PUT',
    });

    const { data } = await api.put(`database/action_log`, action);
    return data[0];
  } catch (e) {
    throw e;
  }
}

export const actionLogQuest = (operation: string, player: string, item: string) => {
  return new Promise((resolve, reject) => {
    const payload = {
      operation: operation,
      item: item,
      player: player,
    };

    api
      .put('/database/social_quests_log__c', payload)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export async function viewedRSModal(): Promise<{ viewed: boolean }> {
  try {
    const watched = window.localStorage.getItem('watched_RS_video');
    const { data } = await api.post(`find/sos_funcis_bb_rs`, {});
    return { viewed: !!watched || (data.length && data[0].viewed) };
  } catch (e) {
    return { viewed: false };
  }
}

export async function pushPlayerAction(operation: string, request: any) {
  try {
    const payload = {
      operation,
      request,
    };
    const { data } = await api.put(`database/player_actions__c`, payload);
    return data[0];
  } catch (e) {
    console.error(e);
    // throw e;
  }
}

export async function getActiveGame() {
  try {
    const payload = {};
    const { data }: { data: { drawGame?: string | undefined; played: boolean; interaction: boolean }[] } = await api.post(
      `find/get_active_game`,
      payload,
    );
    return data[0];
  } catch (e) {
    console.error(e);
    // throw e;
  }
}

export async function verifySentPoints(_id: string, target: string, text?: string) {
  try {
    const payload = {
      _id,
      target,
      text,
    };
    const { data } = await api.put(`database/verify_recognition__c`, payload);
    return data;
  } catch (e) {
    console.error(e);
  }
}
